// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"EditCategoryModal_inputContainer__1eeLp"};